import React from 'react';
import { SearchInput, Select, Button } from '@/components/ui';
import type { ProgressFilters, ProgressLogStatus } from '../types/construction-progress.types';

interface Props {
  filters: ProgressFilters;
  onFilterChange: (filters: ProgressFilters) => void;
  onAdd: () => void;
}

export const ProgressToolbar: React.FC<Props> = ({ filters, onFilterChange, onAdd }) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between bg-white p-4 rounded-2xl border border-slate-100 shadow-sm">
      <div className="flex flex-1 gap-4 w-full md:w-auto">
        <SearchInput
          placeholder="Tìm kiếm nhật ký..."
          value={filters.search}
          onChange={(val) => onFilterChange({ ...filters, search: val })}
          className="max-w-xs"
        />
        <Select
          value={filters.status}
          onValueChange={(val) => onFilterChange({ ...filters, status: val as ProgressLogStatus | 'all' })}
          options={[
            { value: 'all', label: 'Tất cả trạng thái' },
            { value: 'draft', label: 'Bản thảo' },
            { value: 'submitted', label: 'Đã gửi' },
            { value: 'approved', label: 'Đã duyệt' },
            { value: 'rejected', label: 'Từ chối' },
          ]}
          className="w-48"
        />
      </div>
      
      <div className="flex gap-2 w-full md:w-auto">
        <Button variant="outline" icon="ri-filter-3-line">Bộ lọc nâng cao</Button>
        <Button variant="primary" icon="ri-add-line" onClick={onAdd}>Ghi nhận tiến độ</Button>
      </div>
    </div>
  );
};
